import { apiFetch } from "./client.js";

export const authApi = {
  login: ({ login, password, rememberMe }) =>
    apiFetch("/auth/login", {
      method: "POST",
      body: { login, password, rememberMe: !!rememberMe },
    }),
  logout: () => apiFetch("/auth/logout", { method: "POST" }),
  validate: () => apiFetch("/auth/validate", { method: "POST" }),
};

export const healthApi = {
  ping: () => apiFetch("/health"),
};

export const watchApi = {
  list: (params) => {
    const qs = params ? "?" + new URLSearchParams(params).toString() : "";
    return apiFetch(`/watch${qs}`);
  },
  add: (body) => apiFetch("/watch/add", { method: "POST", body }),
  remove: (body) => apiFetch("/watch/remove", { method: "POST", body }),
};

export const lotsApi = {
  lookup: ({ lots, auction = "copart", auctionId }) =>
    apiFetch("/lots/lookup", {
      method: "POST",
      body: { lots: Array.isArray(lots) ? lots : [lots], auction, auctionId },
    }),
  history: (vin) => apiFetch(`/lots/history?vin=${encodeURIComponent(vin)}`),
};

export const carsApi = {
  /**
   * GET /api/cars/:id — accepts VIN, lot number, or BidCars id.
   * Returns combined { bidcars, auctiongate: { history, ... } } payload.
   */
  get: (id) => apiFetch(`/cars/${encodeURIComponent(id)}`),
};

export const AUCTIONS = [
  { value: "copart", label: "Copart (US)" },
  { value: "copart_canada", label: "Copart Canada" },
  { value: "iaai", label: "IAAI (US)" },
  { value: "iaai_canada", label: "IAAI Canada" },
];

export const catalogApi = {
  fee: () => apiFetch("/catalog/fee"),
  feeRemote: () => apiFetch("/catalog/fee/remote"),
  shippers: () => apiFetch("/catalog/shippers"),
  docTypes: () => apiFetch("/catalog/doc-types"),
  landDelivery: () => apiFetch("/catalog/land-delivery"),
};

export const purchasedApi = {
  list: (params) => {
    const qs = params ? "?" + new URLSearchParams(params).toString() : "";
    return apiFetch(`/purchased${qs}`);
  },
};

export const reportsApi = {
  content: (params) => {
    const qs = params ? "?" + new URLSearchParams(params).toString() : "";
    return apiFetch(`/reports${qs}`);
  },
  check: (vin) => apiFetch(`/reports/check?vin=${encodeURIComponent(vin)}`),
  buy: (body) => apiFetch("/reports/buy", { method: "POST", body }),
};

export const userApi = {
  course: () => apiFetch("/user/course"),
  states: () => apiFetch("/user/states"),
  exportData: () => apiFetch("/user/export-data"),
  appLinks: () => apiFetch("/user/app-links"),
  contactInfo: () => apiFetch("/user/contact-info"),
  events: (host) => apiFetch(`/user/events?host=${encodeURIComponent(host || "")}`),
  priceList: (params) => {
    const qs = params ? "?" + new URLSearchParams(params).toString() : "";
    return apiFetch(`/user/price-list${qs}`);
  },
  pricePdf: (body) => apiFetch("/user/price-pdf", { method: "POST", body }),
};

export const similarApi = {
  cars: (body) => apiFetch("/similar/cars", { method: "POST", body }),
  filters: (body) => apiFetch("/similar/filters", { method: "POST", body }),
};

export const invoicesApi = {
  list: ({ userId, page = 1, perPage = 10 } = {}) =>
    apiFetch(`/invoices?user_id=${encodeURIComponent(userId || "")}&page=${page}&per_page=${perPage}`),
  byLot: (body) => apiFetch("/invoices/by-lot", { method: "POST", body }),
  create: (body) => apiFetch("/invoices/create", { method: "POST", body }),
};

export const paymentsApi = {
  save: (body) => apiFetch("/payments/save", { method: "POST", body }),
};

export const bidsApi = {
  save: (body) => apiFetch("/bids/save", { method: "POST", body }),
  active: (body) => apiFetch("/bids/active", { method: "POST", body }),
  log: (body) => apiFetch("/bids/log", { method: "POST", body }),
  checkPurchased: (userSubbiderId) =>
    apiFetch("/bids/check-purchased", {
      method: "POST",
      body: { user_subbiders_id: userSubbiderId },
    }),
};

export const accountsApi = {
  switch: ({ auction, accId }) =>
    apiFetch("/accounts/switch", { method: "POST", body: { auction, accId } }),
  get: ({ auction, accId }) =>
    apiFetch(`/accounts/${encodeURIComponent(auction)}/${encodeURIComponent(accId)}`),
};

export const logApi = {
  visit: (body) => apiFetch("/log/visit", { method: "POST", body }),
  visitStart: (body) => apiFetch("/log/visit-start", { method: "POST", body }),
  auth: (body) => apiFetch("/log/auth", { method: "POST", body }),
  guest: (body) => apiFetch("/log/guest", { method: "POST", body }),
};

export const cookiesApi = {
  clear: (auction) =>
    apiFetch("/cookies/clear", { method: "POST", body: { auction } }),
};

export const logisticsApi = {
  createLead: (body) => apiFetch("/logistics/leads", { method: "POST", body }),
};

Object.assign(userApi, {
  location: () => apiFetch("/user/location"),
  updateBalance: (body) => apiFetch("/user/update-balance", { method: "POST", body }),
  newTitle: (body) => apiFetch("/user/new-title", { method: "POST", body }),
  pdfPayment: (body) => apiFetch("/user/pdf-payment", { method: "POST", body }),
});
